// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import Vue from 'vue'
import App from './App'

// import 'jquery'
// import Layout from './components/Layout'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/myelement.css';
// import '@/../static/css/select2.css';
// import './assets/css/select2.css';

import '../theme/index.css'
import ElementUI from 'element-ui'
import axios from 'axios'

import {API_URL} from '../config/config';
Vue.prototype.$API_URL = API_URL;

// axios.defaults.baseURL = "http://api.biglibrary.cn/api/v1"
// axios.defaults.baseURL = "http://127.0.0.1"
// axios.defaults.baseURL = "http://127.0.0.1:9000"
axios.defaults.baseURL = ""
Vue.prototype.$http = axios
// import $ from 'jquery'
// Vue.use($);
// import './assets/css/login.css'
// 引入ElementUI
// import 'element-ui/lib/theme-chalk/index.css';

// 将ElementUI 注册为vue的全局组件
Vue.use(ElementUI);

// import myaxios from '@/assets/js/myaxios.js'
// Vue.use(myaxios)

// import axios from 'axios';
// var axo = axios.create({
//   baseURL: 'http://localhost:8888/api/private/v1',
// })
// axo.interceptors.request.use(function (conf) {
//   // console.log(conf.url);
//   if (conf.url != '/login') {
//     conf.headers.Authorization = localStorage.getItem('token')
//   }
//   return conf;
// })




Vue.config.productionTip = false

/* eslint-disable no-new */
import router from './router'
new Vue({
  el: '#app',
  router,
  // components: { Layout },
  components: { App },
  // template: '<Layout/>'
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js